import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting/margin-costs";

export default {
  getMarginCost(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getMarginCostList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createMarginCost(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteMarginCost(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateMarginCost(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
